import { useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import LogoutRounded from '@mui/icons-material/LogoutRounded';
import { useAuth } from '../../context/AuthContext';
import { DRAWER_WIDTH } from './Sidebar';

const TopHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const initials = user?.name
    ? user.name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
    : '?';

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        ml: `${DRAWER_WIDTH}px`,
        width: `calc(100% - ${DRAWER_WIDTH}px)`,
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        color: 'text.primary',
      }}
    >
      <Toolbar>
        <Box sx={{ flexGrow: 1 }} />
        <Avatar
          sx={{
            width: 34,
            height: 34,
            mr: 1.5,
            fontSize: '0.8rem',
            fontWeight: 600,
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
          }}
        >
          {initials}
        </Avatar>
        <Typography variant="body2" sx={{ mr: 2, display: { xs: 'none', sm: 'block' } }}>
          {user?.name}
        </Typography>
        <Button
          onClick={handleLogout}
          startIcon={<LogoutRounded />}
          size="small"
          sx={{
            color: 'text.secondary',
            '&:hover': { color: 'text.primary', bgcolor: 'rgba(0,0,0,0.04)' },
          }}
        >
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default TopHeader;
